import { render } from "./MyFriendPage.vue?vue&type=template&id=bc68be20&scoped=true"
import script from "./MyFriendPage.vue?vue&type=script&lang=js"
export * from "./MyFriendPage.vue?vue&type=script&lang=js"

import "./MyFriendPage.vue?vue&type=style&index=0&id=bc68be20&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc68be20"]])

export default __exports__